import React, { useEffect } from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { storage } from '@uhg-abyss/web/tools/storage';
import { Brandmark } from '@uhg-abyss/web/ui/Brandmark';
import { V2Header } from '@uhg-abyss/web/ui/Header';
import { useUser } from '@src/state/user';
import { V2Badge } from '@uhg-abyss/web/ui/Badge';
import { config } from '@uhg-abyss/web/tools/config';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { useTinRegistration } from '@src/state/tinRegistration';
import { useSteps } from '@src/state/steps';
import { useFormV2 } from '@uhg-abyss/web/hooks/useForm';
import { clearForms } from '@src/state/tinRegistration/utils';
import { useLocation } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
import { HAS_SIGNED_OUT } from './SessionTimeout/IdleUser/constants';
import { SessionTimeout } from './SessionTimeout';
import { MyAccount } from './MyAccount';

const HeaderLogo = styled('div', {
  height: 41,
  width: 131,
  cursor: 'pointer',
});

const RightSideLinks = styled('div', {
  textAlign: 'right',
});

const SuperUserBadge = styled('p', {
  height: '8px',
  fontWeight: 500,
});

const BadgeWrapper = styled('div', {
  marginTop: '10px',
});

export const Header = () => {
  const { uuid } = useUser.state();
  const isSuperUser = storage.local.get(uuid);
  const router = useRouter();

  const alertUser = (e) => {
    if (!storage.local.get(HAS_SIGNED_OUT)) {
      e.preventDefault();
      e.returnValue = '';
    }
  };
  const form = useFormV2();
  const { clearStepTracker } = useSteps();
  const { setDocumentId } = useTinRegistration.actions();
  const location = useLocation();

  const goBack = () => {
    if (location.pathname.includes('/confirmation')) {
      clearForms(form, clearStepTracker, setDocumentId, storage);
    }

    router.navigate('/');
  };
  const handleEndConcert = () => {
    if (config('US3671382_SUPER_USER') && isSuperUser) {
      storage.local.remove(uuid);
    }
  };
  useEffect(() => {
    window.addEventListener('beforeunload', alertUser);
    window.addEventListener('unload', handleEndConcert);
    return () => {
      window.removeEventListener('beforeunload', alertUser);
      window.removeEventListener('unload', handleEndConcert);
    };
  }, []);

  return (
    <React.Fragment>
      <SessionTimeout />
      <V2Header.Container>
        <HeaderLogo onClick={goBack}>
          <Brandmark
            affiliate="uhc"
            variant="lockup"
            color="blue"
            brand="uhc"
          />
        </HeaderLogo>
        <V2Header.MainContent>
          <V2Header.Actions>
            <RightSideLinks>
              <MyAccount />
              {config('US3671382_SUPER_USER') && isSuperUser && (
                <BadgeWrapper>
                  <V2Badge variant="neutral" outline>
                    <SuperUserBadge>
                      Super User Status: <b>Active</b>
                    </SuperUserBadge>
                  </V2Badge>
                </BadgeWrapper>
              )}
            </RightSideLinks>
          </V2Header.Actions>
        </V2Header.MainContent>
      </V2Header.Container>
    </React.Fragment>
  );
};
